module.exports = __webpack_public_path__ + "static/pr-op-picking-7e6b46d7a2e17c7a1fd7d105b04050f7.png";